import loadable from "utils/loadable";

export const HalamanProfileOwner = loadable(() => import("./index"));
